// extracted by mini-css-extract-plugin
export default {"header":"Header_header__hwYWZ","buttons":"Header_buttons__P-JPl","buttons__langs":"Header_buttons__langs__lCtCg"};